import * as React from 'react';
import { Button, Tooltip } from 'wix-style-react';
import s from '../PlansGrid.scss';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from 'providers';
import { useTranslation } from 'react-i18next';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { useBreakpoint } from 'providers/BreakpointProvider';
import { MediaDevices } from 'enums';

interface SelectButtonProps {
  onClick(): void;
  isSelected: boolean;
  isDisabled: boolean;
  isSticky?: boolean;
  rootStore: RootStore;
  isCurrentPlanProduct: boolean;
}

const SelectButtonComp: React.FC<SelectButtonProps> = (props) => {
  const { t } = useTranslation();
  const { isDisabled, isCurrentPlanProduct } = props;

  const getDisabledTooltipKey = () => {
    return isCurrentPlanProduct
      ? 'productEntry.current_plan.disabled_tooltip'
      : 'Advanced.Plans_second.upgrade_plan.disabled.tooltip';
  };

  return isDisabled ? (
    <div className={s.tooltipWrapper}>
      <Tooltip
        maxWidth={300}
        padding='20px 25px'
        textAlign='start'
        placement='bottom'
        dataHook='product-select-disabled-tooltip'
        moveBy={{ x: 0, y: 5 }}
        content={t(getDisabledTooltipKey())}
      >
        <SelectButtonInternal {...props} />
      </Tooltip>
    </div>
  ) : (
    <SelectButtonInternal {...props} />
  );
};

const SelectButtonInternal: React.FC<SelectButtonProps> = ({
  onClick,
  isSelected,
  isSticky,
  isDisabled,
  rootStore,
  children,
}) => {
  const { theme } = usePageModeContext();
  const { currentBreakpoint } = useBreakpoint();

  let buttonSize;
  if (currentBreakpoint !== MediaDevices.Desktop) {
    buttonSize = 'small';
  } else {
    buttonSize = isSticky ? 'medium' : 'large';
  }

  return (
    <div
      className={classNames(s.selectButtonWrapper, {
        [s.scaledButton]: isSticky,
      })}
    >
      <Button
        size={buttonSize}
        skin='premium'
        dataHook='select-button'
        fullWidth
        disabled={isDisabled}
        onClick={onClick}
        priority={isSelected && !isDisabled ? 'primary' : 'secondary'}
        className={classNames(
          s.selectButton,
          {
            'sale-button': rootStore.appStore.isInSale && !isDisabled,
          },
          theme,
        )}
      >
        {children}
      </Button>
    </div>
  );
};

export const SelectButton = withInjectedRootStore(SelectButtonComp);
